import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b496a7ca"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"10px","height":"10px"} }, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"10px","height":"10px"} }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"10px","height":"10px"} }, null, -1))

import {
  computed,
  ref,
  onMounted,
  PropType,
  watchEffect
} from 'vue';
import DoctorForm from '@/components/DoctorForm.vue';
import EntityForm from '@/components/EntityForm.vue';
import DoctorPayout from '@/components/DoctorPayout.vue';
import DoctorFiles from '@/components/forms/doctor/DoctorFiles.vue';
import { useModal } from '@/stores/modal';
import { useRoute } from 'vue-router';
import { Doctor } from '@/interfaces/Doctor';
import { RegisterRequest } from '@/interfaces/RegisterRequest';
import RegisterRequestService from '@/services/RegisterRequestService';
import DoctorEntityService from '@/services/DoctorEntityService';


export default /*#__PURE__*/_defineComponent({
  __name: 'DoctorInvite',
  props: {
  modelValue: {
    type: Object as PropType<Doctor>,
    default: () => ({})
  }
},
  emits: ['update:modelValue'],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;
const modal = useModal();
const route = useRoute();
const doctorEntityService = new DoctorEntityService();

const doctor = ref<Doctor>({
  ...props.modelValue,
  deviceType: '',
  title: 'Dr.',
  entity: {
    ...props.modelValue.entity!,
    invoiceSerial: 'DR',
    invoiceCurrentNumber: '1',
    contractDate:
      props.modelValue.entity?.contractDate ||
      new Date().toISOString().substr(0, 10) // Set default value to today
  }
});

const isValidForm = ref(false);
const isValidPayoutForm = ref(false);
const isValidEntityForm = ref(false);
const request = ref<RegisterRequest>() || ({} as RegisterRequest);
const requestId = computed(() => route.query.requestId);

watchEffect(() => {
  const updatedDoctor = { ...doctor.value } as Doctor;
  if (doctor.value) {
    emit('update:modelValue', updatedDoctor);
  }
});

const fetchRegisterRequest = async (requestId: string) => {
  try {
    request.value =
      await RegisterRequestService.fetchRegisterRequest(requestId);
    doctor.value.firstName = request.value.firstName;
    doctor.value.lastName = request.value.lastName;
    doctor.value.specialization = request.value.specialty;
    doctor.value.phoneNo = request.value.phone;
    doctor.value.email = request.value.email;
    doctor.value.requestId = request.value.id;
  } catch (error) {
    console.error(error as string);
  }
};

const onFormValidationChangeState = (newValue) => {
  isValidForm.value = newValue;
  applyValidation();
};

const onEntityFormValidationChangeState = (newValue) => {
  isValidEntityForm.value = newValue;
  applyValidation();
};

const onPayoutFormValidationChangeState = (newValue) => {
  isValidPayoutForm.value = newValue;
  applyValidation();
};

const applyValidation = () => {
  if (isValidForm.value == false || isValidEntityForm.value == false) {
    modal.restate();
  } else {
    modal.refresh();
  }
};

// Component actions
onMounted(async () => {
  if (requestId.value) {
    fetchRegisterRequest(requestId.value.toString());
  }

  doctorEntityService
    .fetchDoctorNextAvailableContractNumber()
    .then((response) => {
      if (doctor.value.entity) {
        doctor.value.entity.contractNumber = response;
      }
    });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(DoctorForm, {
      modelValue: doctor.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((doctor).value = $event)),
      "onUpdate:formValidationChangeState": onFormValidationChangeState
    }, null, 8, ["modelValue"]),
    _hoisted_1,
    _createVNode(EntityForm, {
      modelValue: doctor.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((doctor).value = $event)),
      "onUpdate:entityFormValidationChangeState": onEntityFormValidationChangeState
    }, null, 8, ["modelValue"]),
    _hoisted_2,
    _createVNode(DoctorPayout, {
      modelValue: doctor.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((doctor).value = $event)),
      "onUpdate:payoutFormValidationChangeState": onPayoutFormValidationChangeState
    }, null, 8, ["modelValue"]),
    _hoisted_3,
    _createVNode(DoctorFiles, {
      doctor: doctor.value,
      collect: true
    }, null, 8, ["doctor"])
  ], 64))
}
}

})